// @ts-nocheck

import { CHECKBOX } from "../../modules/checkbox_constants"
import { INDEX } from "../../modules/indexConstants"
import HOOK from "../hooks"

const matchesCountryCheckbox = (countryCode, checkboxes) => {
  const code = (countryCode ?? "").toUpperCase()

  if (!code)
    return false

  return (
    (code === "GB" && CHECKBOX[HOOK.COUNTRY][0].BIT & checkboxes[HOOK.COUNTRY]) ||
    (code !== "GB" && CHECKBOX[HOOK.COUNTRY][1].BIT & checkboxes[HOOK.COUNTRY])
  )
}

const matchesIndustryCheckbox = (industryBit, checkboxes) => {
  if (!industryBit)
    return false

  return !!(industryBit & checkboxes[HOOK.INDUSTRY])
}

const matchesCompanyTypeCheckbox = (aic, checkboxes) => {
  if (aic === undefined)
    return false

  return (!aic && CHECKBOX[HOOK.COMPANY_TYPE][INDEX.CO_TYPE.TRADE].BIT & checkboxes[HOOK.COMPANY_TYPE]) ||
    (aic && CHECKBOX[HOOK.COMPANY_TYPE][INDEX.CO_TYPE.INVEST].BIT & checkboxes[HOOK.COMPANY_TYPE])
}

const matchesLseIndexCheckbox = (lseIndexBit, checkboxes) => {
  if (!lseIndexBit)
    return false

  return !!(lseIndexBit & checkboxes[HOOK.LSE_INDEX])
}

// Returns true if the company matches the checkboxes, false otherwise
const matchesCompany = (company, checkboxes) => (
  matchesLseIndexCheckbox(company.lseIndexBit, checkboxes) &&
  matchesCompanyTypeCheckbox(company.aic, checkboxes) &&
  matchesCountryCheckbox(company.countryCode, checkboxes) &&
  matchesIndustryCheckbox(company.industryBit, checkboxes)
)

const COMPANY_ADVISER_FIELDS = [
  'auditors',
  'recruitingAdvisers',
  'remunerationAdvisers',
  'lastReviewFacilitators',
]

// Filters the company arrays of each adviser based on the checkboxes,
// and removes advisers with no companies after filtering
export const filterAdvisersByCheckbox = ({ items, checkboxes }) => {

  const filteredAdvisers = items
    .map(adviser => {
      const updated = { ...adviser }

      COMPANY_ADVISER_FIELDS.forEach(field => {
        updated[field] = (adviser[field] ?? []).filter(company =>
          matchesCompany(company, checkboxes)
        )
      })

      updated.totalClients = COMPANY_ADVISER_FIELDS.reduce(
        (total, field) =>
          total + (updated[field]?.length ?? 0),
        0
      )

      return updated
    })
    .filter(adviser => adviser.totalClients > 0)

  const totalFilteredClients = filteredAdvisers.reduce(
    (total, adviser) => total + adviser.totalClients,
    0
  )

  return filteredAdvisers.map(adviser => {

    const companyStats = COMPANY_ADVISER_FIELDS.reduce(
      (stats, field) => {

        const adviserTotal = adviser[field]?.length ?? 0

        // TOTAL FOR THIS FIELD ACROSS ALL ADVISERS
        const fieldTotal = filteredAdvisers.reduce(
          (sum, a) => sum + (a[field]?.length ?? 0),
          0
        )

        stats[field] = {
          total: adviserTotal,

          percent:
            fieldTotal === 0
              ? 0
              : Number(
                (
                  (adviserTotal / fieldTotal) * 100
                ).toFixed(1)
              )
        }

        return stats
      },
      {}
    )

    return {
      ...adviser,
      companyStats
    }
  })
}